import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import SearchCardItems from './SearchCardItems';

const SearchCards = ({
  category,
  handleScroll,
  items,
  itemsPerRow,
  onCheckBoxClick,
  readErrors,
  readStatus,
  single,
}) => (
  <InfiniteScrollCards
    canCreate
    className="aridhia-search-cards"
    entity="search"
    handleScroll={handleScroll}
    icon="search"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={`#${relativeUrl(urls.SEARCH)}`}
  >
    <SearchCardItems category={category} items={items} onCheckBoxClick={onCheckBoxClick} single={single} />
  </InfiniteScrollCards>
);

export default SearchCards;
